import StorageEnum from "../enums/Storage.enum.ts";

const prefix = "FRESH-GUARD_";

const prepareKey = (key: string) => {
  return `${prefix}${key}`;
};

const lsSave = (key: string, value: string | object) => {
  localStorage.setItem(prepareKey(key), JSON.stringify(value));
  window.dispatchEvent(new Event("storage"));
};

const lsLoad = (key: string) => {
  const value = localStorage.getItem(prepareKey(key));
  return value ? JSON.parse(value) : null;
};

const lsDrop = (key: string) => {
  localStorage.removeItem(prepareKey(key));
};

const lsClear = () => {
  const usernames = lsLoad(StorageEnum.Usernames);

  localStorage.clear();

  if (usernames !== null) {
    lsSave(StorageEnum.Usernames, usernames);
  }
};

export { lsSave, lsLoad, lsDrop, lsClear };
